export default __webpack_public_path__ + "static/media/greenctg.e51b3bbd.jpg";